// Fallback component to show when an error occurs
export function ErrorFallback({ error }) {
  return (
    <div className={'w-screen h-screen flex items-center justify-center'}>
      <div className={'text-center'}>
          <h2 className={'text-lg m-0'}>Something went wrong:</h2>
          <p className={'text-red-700 m-0 text-xl'}>{error?.message || 'Unknown error'}</p>
      </div>
    </div>
  );
}
